import type { ReactNode } from "react";
import { LegalLinks } from "./legal-links";

/**
 * The frame for the handful of screens that are still PAGES.
 *
 * Almost the whole product is one shell now. What is left outside it is a
 * stranger's door, the demand board and the signed-out landing — three screens
 * that are genuinely addresses, reached from outside, and each one a single
 * column with nothing beside it.
 *
 * The column is the width the reading column always was, so a door reads the
 * same as it did when it sat inside the old rail's main area. What went is the
 * navigation that used to flank it: there are no rooms to navigate between any
 * more, and six links to places that no longer exist would have been the worst
 * possible answer to "where am I".
 */
export function Page({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-bg text-text">
      <main className="mx-auto min-h-screen w-full max-w-[600px] pb-16">
        {children}
        <LegalLinks className="mt-16 px-4 pb-4 sm:px-6" />
      </main>
    </div>
  );
}
